import { render, staticRenderFns } from "./customer-user-create-wizard.vue?vue&type=template&id=4be0fa73&"
import script from "./customer-user-create-wizard.vue?vue&type=script&lang=js&"
export * from "./customer-user-create-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports